import { VStack } from '@wegroup/design-system';
import ProgressBarItem from '@flows/src/components/ui/advisory-flow/components/toolbar/ProgressBarItem';
import { useAnvaFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/anvaFlowsConfigureStore';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlowsConfigureParams } from '@flows/src/hooks/flows-configure/useFlowsConfigureParams';

const FLowsConfigToolbarContent: FC = () => {
  const { t } = useTranslation();
  const insurances = useAnvaFlowsConfigureStore((state) => state.insurances);
  const { insuranceId: insuranceIdParamString } = useFlowsConfigureParams();
  const insuranceIdParam = insuranceIdParamString
    ? Number(insuranceIdParamString)
    : undefined;
  const insuranceIndex = insuranceIdParam
    ? insurances.map(({ id }) => id).indexOf(insuranceIdParam)
    : 0;
  const smallMenuItems = insurances.slice(
    Math.max(insuranceIndex - 1, 0),
    insuranceIndex + 2,
  );
  const isSmallMenu = insurances.length > 6;
  const menuItems = isSmallMenu ? smallMenuItems : insurances;

  return (
    <VStack
      h="100%"
      zIndex="2"
      spacing="2"
      alignItems="stretch"
      justifyContent="center"
      data-test-id="ProdFac_ToolbarProgressBar"
    >
      {!isSmallMenu || insuranceIndex < 2 ? (
        <ProgressBarItem
          isCompleted={!window.location.pathname.endsWith('/insurances')}
          inProgress={window.location.pathname.endsWith('/insurances')}
          disabled
        >
          {t('insurances')}
        </ProgressBarItem>
      ) : (
        isSmallMenu && (
          <ProgressBarItem isCompleted={true} inProgress={false} disabled>
            ...
          </ProgressBarItem>
        )
      )}
      {menuItems.map((insuranceGroup, i) => {
        return (
          <ProgressBarItem
            inProgress={insuranceIdParam === insuranceGroup.id}
            isCompleted={Boolean(
              insuranceIdParam &&
                insurances.map(({ id }) => id).indexOf(insuranceGroup.id) <
                  insuranceIndex,
            )}
            key={insuranceGroup.id}
            disabled
          >
            {insuranceGroup.name}
          </ProgressBarItem>
        );
      })}
      {isSmallMenu && insuranceIndex < insurances.length + 1 && (
        <ProgressBarItem
          inProgress={false}
          isCompleted={false}
          disabled
          data-test-id="ProdFac_ToolbarProgressBar_Complete"
        >
          ...
        </ProgressBarItem>
      )}
    </VStack>
  );
};

export default FLowsConfigToolbarContent;
